import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Grid,
  Typography,
  Button,
  Box,
  styled,
  Link,
  CircularProgress,
} from "@mui/material";
import Header from "components/common/dialog/Header";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { redeemCode } from "redux/slice/session/auth.slice";
import { toast } from "react-toastify";
import Footer from "components/common/dialog/Footer";
import { assetsObj } from "services/images";
import { pathApp } from "services/utiles";
// import toast from "styles/toastUtils"

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#ffffff",
  },
  "&::placeholder": {
    color: "white",
  },
  "&:focus-visible ": {
    outline: "1px solid white",
  },
});

const RedeemGift = () => {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const handleAgreementChange = () => {
    setAgreed(!agreed);
  };

  const formik = useFormik({
    initialValues: {},

    onSubmit: (values) => {
      try {
        setLoading(true);
        dispatch(redeemCode(values))
          .unwrap()
          .then((res) => {
            setLoading(false);
            if (res?.success) {
              navigate(`/success-page`);
              toast.success(res.message);
            }
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error);
            console.log("ererror", error);
          });
      } catch (error) {}
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          background: "black",
          backgroundImage: `url(${assetsObj.Circles})`,
          backgroundSize: "contain",
          backgroundPosition: "left",
          backgroundRepeat: "no-repeat",
          overflow: "auto",
          position: "relative",
          "@media (max-width: 900px)": {
            backgroundImage: "none",
          },
        }}
      >
        <Header />

        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            maxWidth: "auto",
            height: "calc(100vh - 133px)",
            "@media (max-width: 900px)": {
              marginTop: "1rem",
            },
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                className="leftContent"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  marginBottom: 7.2,
                  "@media (max-width: 900px)": {
                    // paddingBottom:1
                    marginBottom: 8.8,
                  },
                }}
              >
                <Box
                  sx={{
                    maxHeight: { lg: "45vh", md: "50vh", xs: "20vh" },
                    position: "relative",
                    marginTop: 4,
                    "@media (max-width: 900px)": {
                      marginTop: 0.1,
                    },
                  }}
                  component="img"
                  src={assetsObj.AffirmateNew}
                />

                <Box
                  sx={{
                    maxHeight: { lg: "100vh", md: "100vh", xs: "100vh" },
                    position: "absolute",
                    marginLeft: 5,
                    "@media (min-width: 899px)": {
                      display: "none",
                    },
                  }}
                  component="img"
                  src={assetsObj.Circles}
                />
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid
                  spacing={2}
                  container
                  item
                  xs={11}
                  md={8}
                  sx={{
                    margin: "auto",
                    "@media (max-width: 900px)": {
                      margin: 0,
                    },
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 300,
                        marginBottom: 2,
                        textAlign: "center",
                        background:
                          "linear-gradient(90deg, rgba(191,90,242,1) 0%, rgba(123,90,255,1) 100%)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      Redeem Gift
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: 1 }}>
                    <WhiteBorderTextField
                      placeholder="Enter your gift code"
                      type="text"
                      name="redeem_code"
                      onChange={formik.handleChange}
                      value={formik.values.redeem_code}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ marginBottom: 1 }}>
                    <Typography
                      onChange={handleAgreementChange}
                      sx={{
                        color: "white",
                        fontSize: "14px",
                        fontWeight: 600,
                        "@media (max-width: 430px)": {
                          fontSize: "12px",
                        },
                        "@media (max-width: 370px)": {
                          fontSize: "10px",
                        },
                      }}
                    >
                      By clicking Redeem, you agree to the {""}
                      <Link
                        href="https://affirmate.app/gift-terms/"
                        sx={{ color: "white", textDecorationColor: "white" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of the Gift Card.
                      </Link>
                    </Typography>
                    <Typography
                      onChange={handleAgreementChange}
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "14px",
                        marginTop: 2,
                        fontWeight: 600,
                        "@media (max-width: 430px)": {
                          fontSize: "12px",
                        },
                        "@media (max-width: 370px)": {
                          fontSize: "10px",
                        },
                      }}
                    >
                      If you're currently subscribed to Affirmate, kindly wait
                      for your subscription to end before using the Gift Card.
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      // onClick={handleSignUp}
                      sx={{
                        borderRadius: "60px",
                        marginTop: 1,
                        width: "50%",
                        background: "transparent",
                        border: "1px solid white",
                        "&:hover": {
                          background: "white",
                          color: "black",
                          transition: "0.2s ease-in-out",
                        },
                        mx: "auto",
                      }}
                      type="submit"
                    >
                      {loading ? (
                        <CircularProgress size={22} color="secondary" />
                      ) : (
                        "Redeem"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>

        <Footer />
      </Box>
    </>
  );
};

export default RedeemGift;
